import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-79">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50" data-id="element-80" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-81">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-[#1A1A1A] border border-[#333] w-full max-w-2xl max-h-[80vh] rounded-2xl shadow-2xl flex flex-col pointer-events-auto" data-id="element-82">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#333]" data-id="element-83">
                <h3 className="text-xl font-serif text-[#F5F0E8]" data-id="element-84">{title}</h3>
                <button onClick={onClose} className="text-[#A89F91] hover:text-[#D4A853] transition-colors p-1" data-id="element-85">
                  <X className="w-6 h-6" data-id="element-86" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto custom-scrollbar text-[#A89F91] space-y-4 text-sm leading-relaxed" data-id="element-87">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}